import { StatusBadge } from "../../../components/ui/StatusBadge";
import { RecorderButton } from "../../consultation-recorder";

/** Navigation and appointment lifecycle actions for a consultation. */
export function ConsultationToolbar({
  activeTab,
  appointment,
  actionsDisabled,
  isLoading,
  onTabChange,
  onReadMessages,
  onToggleChat,
  onFinish,
  recorder,
}) {

  const selectMessages = () => {
    onTabChange("message");
    onReadMessages(appointment?.patient_id);
  };

  const selectRobot = () => {
    onTabChange("robort");
    onToggleChat();
  };

  return (
    <div className="TabTopSec">
      <ul className="TabNav">
        <li
          className={activeTab === "observations" ? "active" : ""}
          onClick={() => onTabChange("observations")}
        >
          Observations
        </li>
        <li
          className={activeTab === "new-prescriptor" ? "active" : ""}
          onClick={() => onTabChange("new-prescriptor")}
        >
          Prescripteur
        </li>
        <li
          className={activeTab === "message" ? "active" : ""}
          onClick={selectMessages}
        >
          message
          {appointment?.patient_read_count > 0 ? (
            <span className="unreadMarker" />
          ) : null}
        </li>
        <li
          className={activeTab === "payment-management" ? "active" : ""}
          onClick={() => onTabChange("payment-management")}
        >
          Payment
        </li>
        <li
          className={activeTab === "cobot" ? "active" : ""}
          onClick={() => onTabChange("cobot")}
          style={{ color: "red" }}
        >
          <span className="cobot-tab-label cobot-tab-label-full">Assistant</span>
          <span className="cobot-tab-label cobot-tab-label-short">Assistant</span>
        </li>
        <li
          className={activeTab === "robort" ? "active" : ""}
          onClick={selectRobot}
        />

        <li
          style={{
            marginLeft: "auto",
            marginRight: "200px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            height: "0px",
          }}
        >
          {!isLoading ? (
            appointment?.status === 3 || appointment?.status === 2 ? (
              <div style={{ marginTop: "23px" }}>
                <StatusBadge
                  label={appointment?.status === 3 ? "Absent" : "Cancelled"}
                  tone={appointment?.status === 3 ? "warning" : "danger"}
                />
              </div>
            ) : (
              <>
                {/* The recorder is a note-taking aid — keep it usable even on a
                    finished or past-dated appointment (only the Finish action is
                    gated by `actionsDisabled`). */}
                <RecorderButton
                  recorder={recorder}
                  disabled={false}
                />

                {appointment?.finish === 2 ? (
                  <button
                    className="FinishBtn"
                    disabled
                    style={{ marginTop: "23px", marginRight: "8px" }}
                    type="button"
                  >
                    Finished
                  </button>
                ) : (
                  <button
                    className="FinishBtn"
                    disabled={actionsDisabled}
                    onClick={onFinish}
                    style={{ marginTop: "23px", marginRight: "8px" }}
                    type="button"
                  >
                    Finish
                  </button>
                )}
              </>
            )
          ) : null}
        </li>
      </ul>
    </div>
  );
}
